import CheckedIcon from '@mui/icons-material/CheckBoxRounded';
import type { CheckboxProps } from '@mui/material';
import { Checkbox as MUICheckbox, SvgIcon } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Checkbox = styled((props: CheckboxProps) => {
  return (
    <MUICheckbox
      size="small"
      disableFocusRipple
      icon={
        <SvgIcon>
          <svg
            viewBox="0 0 16 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="2.5"
              width="15"
              height="15"
              rx="1.5"
              stroke="#7E828F"
            />
          </svg>
        </SvgIcon>
      }
      checkedIcon={<CheckedIcon color="primary" />}
      {...props}
    />
  );
})(() => ({
  padding: 0,
  marginLeft: 0,
  borderRadius: 4,

  '&:hover': {
    outline: `3px solid #E7ECFA`,
    outlineOffset: -1,
  },

  '&.Mui-focusVisible': {
    outline: `3px solid #8832EA`,
    outlineOffset: 0,
  },
}));
